import { MapPin, Navigation } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES, MAPS_EMBED, MAPS_URL } from "@/lib/constants";

export const Location = () => (
  <section id="localizacao" data-testid="location-section" className="bg-cob-beige/50 py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        overline="Localização"
        title="Estamos em Teresina"
        text="Teresina – PI | Zona Norte"
      />

      <div className="mt-12 grid lg:grid-cols-2 gap-8 items-stretch">
        <Reveal className="h-full">
          <div className="relative h-full min-h-[320px] overflow-hidden rounded-[1.8rem]">
            <img loading="lazy" decoding="async"
              src={IMAGES.facade}
              alt="Fachada da Clínica COB em Teresina"
              data-testid="location-image"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-cob-dark/80 via-cob-dark/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-7">
              <p className="inline-flex items-center gap-2 text-sm font-semibold text-white">
                <MapPin className="h-4.5 w-4.5 text-cob-gold" />
                Teresina – PI | Zona Norte
              </p>
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-directions-button"
                className="mt-4 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-[13px] font-semibold text-cob-dark transition-colors duration-300 hover:bg-cob-gold"
              >
                <Navigation className="h-4 w-4" />
                Como chegar
              </a>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="h-full">
          <div className="h-full min-h-[320px] overflow-hidden rounded-[1.8rem] border border-cob-light shadow-[0_18px_45px_-25px_rgba(6,63,50,0.35)]">
            <iframe
              title="Mapa da Clínica COB — Zona Norte, Teresina"
              data-testid="location-map-iframe"
              src={MAPS_EMBED}
              className="h-full min-h-[320px] w-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
